'use client';

import React from 'react';
import cn from 'clsx';
import styles from './Carousel.module.scss';

type CardProps = {
  currentIndex: number;
  index: number;
  cardWidth: number;
  child: React.ReactNode;
  marginRight: number;
  listLen: number;
};

const CarouselCard = ({ currentIndex, index, cardWidth, child, marginRight, listLen }: CardProps) => {
  return (
    <div
      className={cn(
        styles.carouselSlide,
        'c_slide',
        {
          'c_slide_active': currentIndex === index,
          [styles.carouselDefault]: (cardWidth === 0)
        }
      )}
      key={index}
      style={cardWidth ? { width: `${cardWidth}px`, ...((index + 1) !== listLen && { marginRight: `${marginRight}px` }) } : null}
    >
      {child}
    </div>
  )
}

export default React.memo(CarouselCard);